module.exports = __webpack_public_path__ + "img/new2-3.b8619416.jpg";